import styled from 'styled-components';

import { ReactComponent as Play } from '../../../../assets/icons/play.svg';
import { ReactComponent as Check } from '../../../../assets/icons/check.svg';

import { colors, typography, spacing } from '../../../../styles/theme';

export const Container = styled.div`
  position: relative;
`;

export const Button = styled.button`
  position: relative;
  display: flex;
  padding: ${spacing('1')};
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  color: ${colors('black.base')};
  text-decoration: none;
  box-sizing: border-box;

  outline: none;
  background: transparent;

  margin-right: 30px;
  mix-blend-mode: normal;
  border-radius: 5px;
  border: none !important;
  transition: 0.2s ease-in-out;
  cursor: pointer;

  font: 500 14px ${typography('fontFamily')};
  line-height: 20px;
  font-style: normal;

  &:hover {
    background: ${colors('primary.light')};
    transition: 0.2s ease-in-out;
  }

  &.active {
    background: ${colors('primary.light')};
    transition: 0.2s ease-in-out;
  }
`;

export const Badge = styled.div`
  position: absolute;
  top: ${spacing('small')};
  right: 0;
  height: 8px;
  width: 8px;
  border-radius: 8px;
  background-color: ${colors('red.base')};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: ${spacing('2')};

  max-height: 320px;
  min-width: 360px;

  overflow-y: auto;
  overflow-x: hidden;
`;

export const Item = styled.li`
  width: calc(100% - (19px * 2));
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: ${spacing('1')} 20px;
  cursor: pointer;
  transition: 0.2s ease-in-out;

  &:hover {
    transition: 0.2s ease-in-out;
    background: ${colors('black.08')};
  }
`;

export const VideoInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  margin-left: 10px;

  h6 {
    ${typography('caption1')}
    font-weight: normal;
    color: ${colors('black.base')};
  }

  p {
    ${typography('caption2')}
    color: ${colors('black.50')};
    margin-top: 3px;
  }
`;

export const ImageWrapper = styled.div`
  width: 66px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  border-radius: 4px;

  flex-shrink: 0;

  .purple-bg {
    background: rgba(77, 70, 223, 0.4);
    opacity: 0.9;
    width: 66px;
    height: 50px;
    border-radius: 4px;
    position: absolute;
    top: 0;
    right: 0;
  }
`;

export const Image = styled.img`
  width: 100%;
  border-radius: 4px;
  display: block;
`;

export const Link = styled.a`
  height: 16px;
  width: 100%;

  font: 500 12px ${typography('fontFamily')};
  text-transform: uppercase;
  text-decoration: none;
  line-height: 16px;

  letter-spacing: 0.002em;

  color: ${colors('black.50')};

  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: inset 0px 1px 0px rgba(35, 43, 51, 0.08);
  transition: 0.2s ease-in-out;

  margin-top: 10px;

  &:hover {
    transition: 0.2s ease-in-out;
    background: ${colors('black.08')};
    color: ${colors('primary.base')};
  }
`;

export const PlayIcon = styled(Play)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.4);
  position: absolute;
  margin: auto;
`;

export const CheckIcon = styled(Check)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  margin: auto;
`;
